const ResultActionTypes = {
    FETCH_COLLECTIONS_START: 'FETCH_COLLECTIONS_START',
    FETCH_COLLECTIONS_SUCCESS: 'FETCH_COLLECTIONS_SUCCESS',
    FETCH_COLLECTIONS_FAILURE: 'FETCH_COLLECTIONS_FAILURE',
    DELETE_RESULTS_ITEM: 'DELETE_RESULTS_ITEM',
    CLEAR_RESULTS: 'CLEAR_RESULTS',
};

export default ResultActionTypes;